import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IUpdate } from "interface/updates";
import updateNotification from '../../services/updateNotification';
import { toastError } from 'utils/reduxToast';

export interface UpdatesState {
   data: IUpdate[];
}

const initialState: UpdatesState = {
    data: []
  };

export const fetchUpdates = createAsyncThunk(
  'updatesNotifications/fetchUpdates',
    () => updateNotification.fetchUpdates().catch(() => toastError('Ops! algo deu errado ao trazer as notificações'))
);

export const readAndUnreadUpdate = createAsyncThunk(
  'updatesNotifications/readAndUnreadUpdate',
  (payload: { id: string, read: boolean }) => updateNotification.readAndUnreadUpdate(payload).catch(() => toastError('Ops! algo deu errado'))
);

export const deleteUpdate = createAsyncThunk(
  'updatesNotifications/deleteUpdate',
  (payload: {id: string}) => updateNotification.deleteUpdate(payload).catch(() => toastError('Ops! algo deu errado'))
);

export const markAllAsRead = createAsyncThunk(
  'updatesNotifications/markAllAsRead',
  () => updateNotification.markAllAsRead().catch(() => toastError('Ops! algo deu errado'))
);

export const updateNotificationsSlice = createSlice({
  name: 'updatesNotifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUpdates.fulfilled, (state, action) => {
        state.data = action?.payload?.data?.data
      })
      .addCase(readAndUnreadUpdate.fulfilled, (state, {meta}) => {
        state.data = [...state.data.map(u => {
          if (u.id !== meta.arg.id) {
            return u
          }
          u.read = meta.arg.read;
          return u;
        })];
      })
      .addCase(deleteUpdate.fulfilled, (state, {meta}) => {
        state.data = [ ...state.data.filter(u => u.id !== meta.arg.id) ]
      })
      .addCase(markAllAsRead.fulfilled, (state) => {
        state.data = [ ...state.data.map(u => { return { ...u, read: true } }) ];
      })
  },
});

export default updateNotificationsSlice.reducer;
